import { defineMessages } from "react-intl";

export default defineMessages({
  academy_recurrency: {
    id: "repeatRate.academy_recurrency",
    defaultMessage:
      "/nl/academy/wat-zijn-de-voordelen-van-een-terugkerende-job",
  },
  academy_realisation: {
    id: "realisationRate.academy_realisation",
    defaultMessage: "/nl/academy/annulaties-daar-wordt-niemand-blij-van",
  },
  super_talent_url: {
    id: "super_talent_url",
    defaultMessage: "/nl/supertalent",
  },
  chart_url: {
    id: "chart_url",
    defaultMessage: "/nl/listworker-rules",
  },
  instant_matching_url: {
    id: "instant_matching_url",
    defaultMessage: "/nl/instant_matching",
  },
  sp_evaluations_url: {
    id: "sp_evaluations_url",
    defaultMessage: "/nl/evaluations/new",
  },
});
